import Vue from 'vue'

Vue.prototype.$rjscOrgId = 15
